import { render, staticRenderFns } from "./modal-header.component.vue?vue&type=template&id=bfadaf2a&scoped=true&"
import script from "./modal-header.component.vue?vue&type=script&lang=ts&"
export * from "./modal-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./modal-header.component.vue?vue&type=style&index=0&id=bfadaf2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfadaf2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
